export function createImageFileFromUrl(
  imageUrl: string,
  fileName: string = 'image.jpg'
): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    // Set crossOrigin only if the imageUrl is not a data URL or blob URL
    if (!imageUrl.startsWith('data:') && !imageUrl.startsWith('blob:')) {
      img.crossOrigin = 'anonymous';
    }
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject('No canvas context');
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(blob => {
        if (!blob) return reject('Failed to create blob');
        const file = new File([blob], fileName, { type: 'image/jpeg' });
        resolve(file);
      }, 'image/jpeg');
    };
    img.onerror = reject;
    img.src = imageUrl;
  });
}
